export default __webpack_public_path__ + "static/media/express.2b9f20b2.svg";